/**
 * aggregator-status-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

import { ActivityProgress } from "./activity-progress";

/**
 * The {@link AggregatorStatusResponse} provides a progress update on an
 * aggregator, usually while it is active. These statuses are issued
 * intermittently by the server while an aggregator executes; they may also be
 * requested explicitly by the corresponding {@link AggregatorStatusRequest}.
 */
@validateFor(MessageTag.RSP_STATUS_AGGREGATOR)
export class AggregatorStatusResponse extends IncomingMessage
  implements ActivityProgress
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_STATUS_AGGREGATOR;

  @validateOpaqueID()
  public aggregationId : number;

  @validateAs("integer")
  public viable : number;

  @validateAs("integer")
  public processed : number;

  @validateAs("integer")
  public rejected : number;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/aggregator-status-response.ts